import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'
import Container from 'typedi'
import RemoteSupportService from '../services/remote-support.service'

@Module({
  namespaced: true
})
export default class RemoteSupportStore extends VuexModule {
  remoteSupport: { enabled: boolean } = { enabled: false }

  @Mutation
  SET_REMOTE_SUPPORT (payload: { enabled: boolean }) {
    this.remoteSupport = payload
  }

  @Action({ rawError: true })
  async fetchRemoteSupport (event_uuid: string) {
    this.context.commit('SET_REMOTE_SUPPORT', { enabled: false })
    const response: any = await Container.get(RemoteSupportService).getRemoteSupport(event_uuid)
    this.context.commit('SET_REMOTE_SUPPORT', { enabled: response.data.remote_support_enabled })
  }

  @Action({ rawError: true })
  async saveRemoteSupport (payload: { event_uuid: string; enabled: boolean }) {
    const response: any = await Container.get(RemoteSupportService).updateRemoteSupport(payload.event_uuid, payload.enabled)
    this.context.commit('SET_REMOTE_SUPPORT', { enabled: response.data.remote_support_enabled })
    // Keep the shared event object in sync so the support widget (which reads
    // event.event.remote_support_enabled) swaps immediately, without requiring a page nav.
    if (this.context.rootState.event?.event) {
      this.context.commit('event/SET_EVENT', {
        ...this.context.rootState.event.event,
        remote_support_enabled: response.data.remote_support_enabled
      }, { root: true })
    }
  }
}
